__turbopack_context__.v({
  "root": "p_wZQG_root",
  "tab": "p_wZQG_tab",
  "tabActive": "p_wZQG_tabActive",
});
